import { useWindow } from "../../../contexts/WindowContext";
import { useAuth } from "../../../contexts/AuthContext";

interface SignUpButtonProps {
  minimize?: boolean;
}

export const SignUpButton = ({ minimize = false }: SignUpButtonProps) => {
  const auth = useAuth();
  const { windowWidth } = useWindow()

  return (
    <button
      onClick={() => auth.login()}
      className="auth-button sign-up"
    >
      Sign Up{!(minimize && windowWidth < 768) && " for Free"}
    </button>
  );
};